export default () => ({
	email: '',
	success: false,
	error: '',
	loading: false,

	async submit() {
		try {
			this.loading = true
			this.error = ''

			const form = this.$el
			const formData = new URLSearchParams(new FormData(form) as any)

			const response = await fetch('/contact', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					Accept: 'application/json',
				},
				body: formData.toString(),
			})

			if (!response.ok) {
				throw new Error('Submission failed')
			}

			this.success = true
			this.email = ''
		} catch (err) {
			this.error = 'There was an error submitting the form. Please try again.'
			console.error('Newsletter submission error:', err)
		} finally {
			this.loading = false
		}
	},
})
